module.exports = "/_next/static/images/video_id_7104369752495230250-86012d4082348650c9b30e0563ec2e96.jpg";